import React, { useState, useEffect } from 'react';
import '../css/tabMenu.css';
import Mapa3D from './Mapa3D.jsx';
import Blockchain from './Blockchain.jsx';
import PaneldeSupervision from './PaneldeSupervision.jsx';
import MonitoreodeEntrenamiento from './MonitoriodeEntrenamiento.jsx';
import { IoMenu } from "react-icons/io5";

function TabMenu() {
  const [activeTab, setActiveTab] = useState('Ciudad Inteligente');
  const [content, setContent] = useState(null);
  const [menuVisible, setMenuVisible] = useState(false);

  const loadContent = (tab) => {
    switch (tab) {
      case 'Ciudad Inteligente':
        return <Mapa3D />;
      case 'Panel de Supervisión': 
        return <PaneldeSupervision />;
      case 'Monitoreo de Entrenamiento':
        return <MonitoreodeEntrenamiento />;
      case 'Red de Blockchain':
        return <Blockchain />;
      default:
        return null;
    }
  };

  useEffect(() => {
    const hash = decodeURIComponent(window.location.hash.replace('#', ''));
    const defaultTab = 'Ciudad Inteligente';
    if (hash) {
      setActiveTab(hash);
      setContent(loadContent(hash)); 
    } else {
      setActiveTab(defaultTab);
      setContent(loadContent(defaultTab)); 
    }
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setMenuVisible(false);
    window.location.hash = tab; 
    setContent(loadContent(tab)); 
  };

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  return (
    <div>
      <div className="tab-menu">
        <button className="menu-toggle" onClick={toggleMenu}>
          <IoMenu /> Menú
        </button>
        <div className={`tabs-container ${menuVisible ? 'show' : ''}`}>
          <div
            className={`tab ${activeTab === 'Ciudad Inteligente' ? 'active' : ''}`}
            onClick={() => handleTabClick('Ciudad Inteligente')}
          >
            Ciudad Inteligente
          </div>
          <div
            className={`tab ${activeTab === 'Panel de Supervisión' ? 'active' : ''}`} 
            onClick={() => handleTabClick('Panel de Supervisión')}
          >
            Panel de Supervisión
          </div>
          <div
            className={`tab ${activeTab === 'Monitoreo de Entrenamiento' ? 'active' : ''}`}
            onClick={() => handleTabClick('Monitoreo de Entrenamiento')}
          >
            Monitoreo de Entrenamiento
          </div>
          <div
            className={`tab ${activeTab === 'Red de Blockchain' ? 'active' : ''}`}
            onClick={() => handleTabClick('Red de Blockchain')}
          >
            Red de Blockchain
          </div>
        </div>
      </div>
      <div className="content">
        {content}
      </div>
    </div>
  );
}

export default TabMenu;
